<a
    [attr.data-btnId]="getElementId('openElementInfo')"
    ngbTooltip="{{ 'Open information window' | translate }}"
    (click)="openDetails()">
    <fa-icon [icon]="['fas', icon]"></fa-icon>
</a>
